import * as React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useStores } from "hooks";
import { Grid } from "@material-ui/core";
import { BlockWrapper, TextRow, Typography } from "components";
import { formatAmount, useBreakpoints } from "utils";
import { Currency } from "enums";
import { useStyles } from './Description.styles';
import { TEXT } from "texts";

const Description = () => {
  const { t } = useTranslation();
  const { dataStore } = useStores();
  const { isMd } = useBreakpoints()
  const styles = useStyles();

  if (!isMd) return null;
  const formattedAmount = formatAmount({ amount: dataStore.appData?.amount });
  const isAmountNull = !Number(dataStore.appData?.amount);
  const title = isAmountNull ? t(TEXT.totalAmountEmpty) : t(TEXT.totalAmount);
  const text = isAmountNull ? '' : `${formattedAmount} ${Currency.UAH}`;

  return (
    dataStore.appData &&
    <Grid container direction="column" className={styles.details}>
      <Typography textType="large" fontWeight={600} align="center">
        {dataStore.appData.recipient.purposeText}
      </Typography>

      <BlockWrapper mt={isAmountNull ? 1 : 3} hasWrap={!isAmountNull}>
        <TextRow
          title={title}
          text={text}
        />
      </BlockWrapper>
    </Grid>
  )
}

export default observer(Description)